/***
 * @Authors:
 *      Ashwin Rai (ashwinrai.com)
 *      Nikhil Chougule
 ***/

/*** Imports ***/

/* Library imports */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/* Component imports */
import * as UtilityLg from "../../../UtilityLg";

/* Style imports */
import './styles.css'
import ConstantsLg from "../../../ConstantsLg";

/*** End Imports ***/


export default class TextboxLg extends Component {

    constructor (props) {
        super(props);
        this.state = {
            hasValue: false,
            hasError: false,
            isValid : true,
            isDirty : false
        };
        this._responseObj = {
            hasValue: false,
            hasError: false,
            isValid : false,
        };

        UtilityLg.bindThisToAll(this, 'onFocus', 'onBlur','onChange','validateManually', 'onKeyDown');

        this.isInputFieldActive = false;
    }

    componentDidMount(){
        if(this.props.value !== null && this.props.value !== undefined && String(this.props.value) !== ""){
            this.inputBox.value = this.props.value;
            this.validateManually();
        }
    }

    componentDidUpdate () {

    }

    _set_validation_status = (obj) =>{
        if(this.state.hasError !== obj.hasError || this.state.hasValue !== obj.hasValue || this.state.isValid !== obj.isValid) {
            this.setState({
                hasValue: obj.hasValue,
                hasError: obj.hasError,
                isValid: obj.isValid
            });
        }
    };

    _set_is_dirty = (bool) =>{
        if(this.state.isDirty !== bool)
            this.setState({
                isDirty : bool
            });
    };

    validateManually(){
        this.validate(this.props.value);
    }

    showAsInvalid(){
        const {isValid} = this.state;
        if(isValid !== false){
            this._set_validation_status({
                isValid: false
            });
        }
    }

    showInviteOnly(){
        const {isValid} = this.state;
        if(isValid !== false){
            this._set_validation_status({
                isValid: false
            });
        }
    }

    onFocus(event) {

        this._set_validation_status({
            hasValue: false,
            hasError: false,
            isValid : true,
        });

        if(!this.state.isDirty){
            this._set_is_dirty(true);
        }

    }

    onBlur(event) {
        if(this.state.isDirty){
            this.validate(event.currentTarget.value);
        }
        this.props.onBlurPassword && this.props.onBlurPassword(event.target.val);
    }

    onChange(event) {
        // this.validate(event.currentTarget.value);
        //FIXME issue with the following code is that we can not be sure when the setState is going to be called
        // FIXME so to responed back to parent we use local private object

        this.pseudoValidation(event.target.value);
    }

    onKeyDown (event){
        if(event.charCode === ConstantsLg.KEY_CODE.ENTER){
            event.preventDefault();
            this.props.onEnterClick(this.props.index);
        }
    }

    focusIn = () =>{
        this.inputBox.focus();
    };

    focusOut = () =>{
        this.inputBox.blur();
    };

    pseudoValidation = (value) =>{
        const {pattern, isRequired} = this.props;
        let hasError=false, hasValue, isValid = true;

        hasValue = Boolean(value);
        if(pattern){

            hasError = !pattern.test(value);
        }
        if(isRequired && (!hasValue ||(hasValue && hasError))){
            isValid = false;
        }else if(!isRequired && hasValue && hasError){
            isValid = false;
        }
        this._responseObj['hasError'] = hasError;
        this._responseObj['hasValue'] = hasValue;
        this._responseObj['isValid'] = isValid;
        this._responseObj['isDirty'] = true;
        this.props.onChange(value, this._responseObj);

    };

    validate(value) {
        const {pattern, isRequired} = this.props;
        let hasError=false, hasValue, isValid = true;

        hasValue = Boolean(value);
        if(pattern){
            hasError = !pattern.test(value);
        }
        if(isRequired && (!hasValue ||(hasValue && hasError))){
            isValid = false;
        }else if(!isRequired && hasValue && hasError){
            isValid = false;
        }
        this._responseObj['hasError'] = hasError;
        this._responseObj['hasValue'] = hasValue;
        this._responseObj['isValid'] = isValid;
        this._responseObj['isDirty'] = true;

        this._set_validation_status({
            hasError: hasError,
            hasValue: hasValue,
            isValid: isValid,
            isDirty: true
        });
    }


    render () {
        const {autoComplete, errorMsg, id, isDisabled, maxLength,
            pattern, label, placeholder, type, isRequired, validationMsg, inputTitle
        } = this.props;
        const {hasValue, hasError, isValid} = this.state;

        // https://github.com/JedWatson/classnames
        const inputClasses = classNames('fl-lg-input', {'fl-lg-valid': hasValue && !hasError}, {'fl-lg-invalid': !isValid});

        let labelHolderView = null;
        if(label && label !== "") {
            if (isRequired) {
                labelHolderView = <label className="fl-lg-input-label">
                    <div>
                        {label}
                        <span style={{color: "red"}}> *</span>
                    </div>
                </label>
            } else {
                labelHolderView = <label className="fl-lg-input-label"><div>{label}</div> </label>
            }
        }
        return(
            <div className='fl-lg-input-container' ref={c =>{this.container = c;}}>
                {labelHolderView}
                <input
                    ref = { (val) => { this.inputBox = val}}
                    autoComplete = {autoComplete}
                    className = {inputClasses}
                    disabled = {isDisabled}
                    id = {id}
                    maxLength = {maxLength}
                    onFocus = {this.onFocus}
                    onBlur = {this.onBlur}
                    onChange = {this.onChange}//{pattern ? this.onChange : null}
                    onKeyPress = {this.onKeyDown}
                    placeholder = {placeholder}
                    type = {type}
                    title = {inputTitle}
                    // value={value}
                />
                {(!isValid && hasValue)?<span className={"fl-lg-input-err-msg"}>{validationMsg}</span>: ''}
            </div>
        );
    }
}

TextboxLg.defaultProps = {
    autoComplete: 'off',
    type: 'text',
    isDisabled: false,
    id: 'text-box',
    placeholder: ''
};

TextboxLg.propTypes = {
    autoComplete: PropTypes.bool,
    errorMsg: PropTypes.string,
    placeholder: PropTypes.string.isRequired,
    pattern: PropTypes.any,
    type: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    value: PropTypes.string.isRequired,
    maxLength: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./src/components/core/TextboxLg/TextboxLg.js


// WEBPACK FOOTER //
// ./src/components/core/TextboxLg/TextboxLg.js